import type { TaxCalculationResult } from '#calculator/types'
import { TaxKey, type TaxMetadata } from '#dictionary'
import { TAX_BY_KEY } from '#dictionary/taxes'

import type { ITaxCalculator, NoTaxVariety } from './types'

// TODO: #must be implemented
class AlternativeMinimumTax implements ITaxCalculator<NoTaxVariety> {
  public readonly metadata: TaxMetadata = TAX_BY_KEY.get(
    TaxKey.TaxAlternativeMinimum
  )!

  public getTaxRate(_year: number): number {
    return 0
  }

  public getTaxableThreshold(_year: number): number {
    return 0
  }

  public calculate(_amount: number, _year: number): TaxCalculationResult {
    return {
      amount: 0,
      taxMetadata: this.metadata,
      taxableIncome: 0,
      standardDeduction: 0,
      effectiveRate: 0,
      totalTax: 0,
      bracketBreakdown: [],
    }
  }
}

export default AlternativeMinimumTax
